export const DEFAULT_ENDPOINTS = {
  list: 'wo-sf-task-list',
  mark: 'wo-sf-task-mark'
}

export const DEFAULT_POLICY = 'wealthOwners'
export const DEFAULT_TAG = 'live'

export function buildSeCode (endpoint, suffix) {
  return `se:${endpoint}:${suffix}`
}
